import { useEffect } from 'react';
import { useFeatureFlag, useQueryParams, ONE_DAY_SECONDS } from '@moda/portal-stanchions';
import { useCookies } from './useCookies';

const MAX_AGE_DAYS = 90;
const MAX_AGE_SECONDS = MAX_AGE_DAYS * ONE_DAY_SECONDS;

export const useIsAmexCustomer = () => {
  const isAmexEnabled = useFeatureFlag('amex', [{ default: false }, { if: true, then: true }]);
  const { cookies, setCookie } = useCookies();
  const {
    queryParams: { utm_campaign: utmCampaign }
  } = useQueryParams();
  const isAmexQueryParamPresent = utmCampaign === 'amex_centurion';

  useEffect(() => {
    if (!cookies.isAmexCustomer && isAmexQueryParamPresent)
      setCookie('isAmexCustomer', 'true', MAX_AGE_SECONDS);
  }, [isAmexQueryParamPresent, cookies.isAmexCustomer, setCookie]);

  return isAmexEnabled && (isAmexQueryParamPresent || cookies.isAmexCustomer === 'true');
};
